export default __webpack_public_path__ + "static/view-dashboard-mobile-d32d5015d3011a30d3b8c6b34f6b0ab0.svg";